import { render, staticRenderFns } from "./applyform.vue?vue&type=template&id=66f8379b&scoped=true"
import script from "./applyform.vue?vue&type=script&lang=js"
export * from "./applyform.vue?vue&type=script&lang=js"
import style0 from "./applyform.vue?vue&type=style&index=0&id=66f8379b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f8379b",
  null
  
)

export default component.exports